module.exports = __webpack_public_path__ + "img/end-point.0b7d338e.png";